<app-base-state
  [workOrderState]="workOrderState"
  (refresh)="updateWorkOrderState()"
/>
